"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Select_1 = __importDefault(require("@Components/Selectors/Select"));
require("./index.scss");
const PayeeFilter = (props) => {
    const { payeeOptions, setPayee, selectedPayee } = props;
    return (react_1.default.createElement("div", { className: 'payee-filter-row' },
        react_1.default.createElement("div", { className: 'filter-item' },
            react_1.default.createElement("p", { className: 'small bold' },
                react_1.default.createElement("label", { htmlFor: 'payee-options' }, "Payee:")),
            react_1.default.createElement(Select_1.default, { options: payeeOptions, onValueChange: setPayee, selectedValue: selectedPayee, name: 'payee-options' }))));
};
exports.default = PayeeFilter;
